import React, { useEffect, useState } from "react";
import { Route, Switch } from "react-router-dom";
import { connect } from "react-redux"
import { ConnectedRouter } from "connected-react-router"

import Achieve from "views/Achieve/Achieve"
import DashboardRoutes from "views/Dashboard/DashboardRoutes"
import Dashboard from "views/Dashboard/Dashboard"
import DashboardSuper from "views/Dashboard/DashboardSuper"
import Illustrate from "views/Illustrate/Illustrate"
import Welcome from "views/Welcome/Welcome"
import Maintain from "views/Maintain/Maintain"
import NotFound from "views/Welcome/NotFound"
import Settings from "views/Settings/Settings";
import OneOrg from "views/OneOrg/OneOrg";

import IncidentPage from "views/Dashboard/components/IncidentPage/IncidentPage";
import DownloadAffiliate from "views/Welcome/DownloadAffiliate/DownloadAffiliate";

import Alert from "components/Alert/Alert"
import SessionExpirationModal from "components/SessionExpirationModal/SessionExpirationModal"

import ActionStatusConstants from "helpers/ActionStatusConstants"
import { authGetUserAction } from "store/actions/Actions"

import "Root.scss"
import "@fortawesome/fontawesome-pro/css/all.css"

const Root = (props) => {
  const { authGetUserAction, status, isLoggedIn, userData } = props;

  const [isSuper, setSuper] = useState(false);

  useEffect(() => {
    if (userData && userData.role && userData.role[0]) {
      const isSuper = userData.role[0].is_super === "t" ? true : false;
      setSuper(isSuper);
    } else {
      setSuper(false);
    }
  }, [userData]);


  useEffect(() => {
    authGetUserAction();

    // pure chat
    window.fwSettings = {
      'widget_id': 48000001443
    };
    !function () { if ("function" != typeof window.FreshworksWidget) { var n = function () { n.q.push(arguments) }; n.q = [], window.FreshworksWidget = n } }();
    (function () {
      var script = document.createElement('script');
      script.async = true;
      script.type = 'text/javascript';
      script.src = 'https://widget.freshworks.com/widgets/48000001443.js';
      document.getElementsByTagName('HEAD').item(0).appendChild(script);
    })();

  }, []);

  return (
    <ConnectedRouter history={props.history}>
      <React.Fragment>
        <Alert />
        <SessionExpirationModal />
        {status === ActionStatusConstants.SUCCESS &&
          (isLoggedIn
            ?
            <Switch>
              <Route path="/download/:hash" component={DownloadAffiliate} />
              <Route path="/organization/:orgId" component={OneOrg} />

              <Route exact path="/settings" component={Settings} />
              <Route exact path="/incident" component={IncidentPage} />
              <Route path="/achieve" component={Achieve} />
              <Route path="/dashboard" component={DashboardRoutes} />
              <Route path="/illustrate" component={Illustrate} />
              <Route path="/login" component={Welcome} />
              <Route path="/maintain" component={Maintain} />

              <Route path="/active" component={Dashboard} />

              <Route exact path="/:entity?/:id?" component={isSuper ? DashboardSuper : Dashboard} />

              {/* 404 page */}
              <Route component={NotFound} />

            </Switch>
            :
            <Switch>
              <Route component={Welcome} />
            </Switch>
          )
        }
      </React.Fragment>
    </ConnectedRouter>
  );
}

const mapStateToProps = state => {
  return ({
    userData: state.AuthReducer.userData,
    isLoggedIn: state.AuthReducer.isLoggedIn,
    status: state.AuthReducer.status,
  });
};

const mapDispatchToProps = {
  authGetUserAction
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Root)
